import React from "react";
import More from "../more-screen/More";

const MoreButton = ({
  image,
  title,
  imageWidth,
  imageHeight,
  backgroundColor,
  fontColor,
  disable,
  onClick,
}) => {
  return (
    <div
      onClick={disable ? null : onClick}
      style={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: backgroundColor,
        padding: 10,
        borderRadius: 8,
        WebkitBoxShadow: "0px 5px 10px 3px #00000050",
        justifyContent: "center",
        alignItems: "center",
        margin: 20,
        height: 120,
        opacity: disable ? 0.4 : 1,
        width: 120,
      }}
    >
      <img
        alt="icon"
        src={image}
        style={{ height: imageHeight, width: imageWidth }}
      />
      <div
        style={{
          color: fontColor,
          fontSize: 16,
          fontWeight: "bold",
          textAlign: "center",
          //   marginTop: ,
        }}
      >
        {title}
      </div>
    </div>
  );
};

export default MoreButton;
